import { Images } from "../../Images";
import MineMode from "./MineMode";

export const MineModes = {
    /**
     * @constant
     * @type {MineMode}
     */
    MINE_DEEPER: new MineMode('1', 'Deeper', Images.pick),
    /**
     * @constant
     * @type {MineMode}
     */
    MINE_SHALLOWER: new MineMode('2', 'Shallower', Images.pick),
    /**
     * @constant
     * @type {MineMode}
     */
    MINE_CURRENT: new MineMode('3', 'Current Depth', Images.pick),
    /**
     * @constant
     * @type {MineMode}
     */
    MINE_AUTO: new MineMode('4', 'Automated', Images.pick)

};